import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { AddressComponent } from './checkout/address/address.component';
import { ConfirmationComponent } from './checkout/confirmation/confirmation.component';
import { LandingComponent } from './landing/landing.component';
import { NotFoundComponent } from './not-found/not-found.component';

import { ConfirmationGuard } from './checkout/confirmation/confirmation-guard.service';
import { AddressGuard } from './checkout/address/address-guard.service';
import { AppGuard } from './app-guard.service';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/cart',
    pathMatch: 'full'
  },
  {
    path: 'top',
    redirectTo: '/cart',
    pathMatch: 'full'
  },

  {
    path: 'cart',
    component: CartComponent,
    canActivate: [AppGuard],
    data: {
      step: 'Losbestellung'
    }
  },

  {
    path: 'bestellen',
    component: CheckoutComponent,
    children: [
      { path: '', redirectTo: 'address', pathMatch: 'full' },
      {
        path: 'address',
        component: AddressComponent,
        canActivate: [AddressGuard],
        data: {
          step: 'Persönliche Daten & Zahlungsweise'
        }
      },
      {
        path: 'bestaetigung',
        component: ConfirmationComponent,
        canActivate: [ConfirmationGuard],
        data: {
          step: 'Bestellung überprüfen'
        }
      }
    ]
  },

  {
    path: 'landing',
    component: LandingComponent
  },

  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      useHash: true,
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
